<template>
  <a v-on:click="onPressed" class="back-btn">
    <img src="../assets/arrow-left.svg" />
    <div>Back</div>
  </a>
</template>

<script>
export default {
  methods: {
    onPressed: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.back-btn {
  cursor: pointer;
  width: 65px;
  height: 65px;
  border-radius: 100%;
  background-color: #f1d85b;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #63abcd;
  font-size: 12px;
  letter-spacing: 1.67px;
  text-decoration: none;
  justify-content: center;
  font-weight: bold;
}
</style>
